var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPersonsOne = function SvgPersonsOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 90",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 20.973c3.29 0 5.964 2.651 5.96 5.923V48.29c0 3.272-2.673 5.924-5.964 5.924h-1.447l-.004 31.194c0 2.519-2.056 4.565-4.596 4.565h-6.986c-2.54 0-4.596-2.042-4.596-4.565V54.214H5.96C2.67 54.214 0 51.558 0 48.29V26.896c0-3.272 2.673-5.923 5.964-5.923zm-14.927-4.448A8.982 8.982 0 0 1 6 8.975c0-4.972 4.03-9.002 9-9.002s8.996 4.03 9 9.002a8.99 8.99 0 0 1-4.113 7.55 8.977 8.977 0 0 1-9.774 0z"
  })));
};

export default SvgPersonsOne;